/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./widgetTypeSelect.vue?vue&type=template&id=f225989a"
import script from "./widgetTypeSelect.vue?vue&type=script&lang=js"
export * from "./widgetTypeSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports